export default "__VITE_ASSET__D3BOJY7l__"